import { MapPin } from 'lucide-react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { US_STATES } from '@/lib/usStates'

interface StateFilterSelectProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

export function StateFilterSelect({ value, onChange, className }: StateFilterSelectProps) {
  return (
    <Select value={value || 'all'} onValueChange={(v) => onChange(v === 'all' ? '' : v)}>
      <SelectTrigger className={className}>
        <MapPin className="text-muted-foreground mr-2 size-4" />
        <SelectValue placeholder="State" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All States</SelectItem>
        <SelectSeparator />
        {US_STATES.map(([code, name]) => (
          <SelectItem key={code} value={code}>
            {code} — {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
